import React, { useEffect, useState } from "react";
import {
  ContainerCenter,
  ContainerCenterInside,
  Dashboard,
  Header,
  InputDiv,
  MainContainer,
  TopDiv,
} from "./styles";
import TopBar from "../../components/general/TopBar";
import Menu from "../../components/general/Menu";
import HeaderTable from "./Header";
import NewUserModal from "./NewUserModal";
import DeleteUserModal from "./DeleteUserModal";
import Input from "../../components/general/Input";
import Search from "../../assets/icons/Search";
import Button from "../../components/general/Button";
import UsersDisplay from "./UsersDisplay/index";
import UpgradeRankModal from "./UpgradeRankModal";
import DowngradeRankModal from "./DowngradeRankModal";
import Pagination from "../../components/general/Pagination/index";
import ReactLoading from "react-loading";
import { useSelector, useDispatch } from "react-redux";
import { ProtectedComponent } from "../../components/general/Protected";
import { fetchUsers } from "../../state/users/reducers";
import { useVerifyToken } from "../../hooks/useVerifyToken";
import { useHistory } from "react-router-dom";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";

const MembersPage = ({ location }) => {
  const params = new URLSearchParams(location.search);

  const [userSearch, setUserSearch] = useState(
    params.get("userSearch") ? params.get("userSearch") : ""
  ); //

  const [typeFilter, setTypeFilter] = useState({
    userSearch: params.get("userSearch") ? params.get("userSearch") : "",
    page: params.get("page") ? parseInt(params.get("page")) : 1,
  });

  const users = useSelector((state) => state.users);
  const pagination = users.pagination;
  const user = useSelector((state) => state.auth.user);

  const [selectedItem, setSelectedItem] = useState({});
  const [openModal, setOpenModal] = useState("none");

  const history = useHistory();

  const updateFilters = ({ ...typeFilter }) => {
    setTypeFilter({ ...typeFilter });
    setUrlParams({ ...typeFilter });
  };

  const { promiseInProgress: isFetching } = usePromiseTracker({
    area: "fetching-users",
  });

  const setUrlParams = ({ ...typeFilter }) => {
    history.push({
      search:
        "?" +
        new URLSearchParams({
          ...typeFilter,
        }).toString(),
    });
  };

  const handleCloseModal = () => {
    setOpenModal("none");
  };

  const handleTurnColaborator = (e) => {
    setSelectedItem(e);
    setOpenModal("downgrade");
  };

  const handleTurnManager = (e) => {
    setSelectedItem(e);
    setOpenModal("upgrade");
  };

  const handleDeleteUser = (e) => {
    setSelectedItem(e);
    setOpenModal("delete");
  };

  const Placeholder = () => console.log("IN PROGRESS");

  const dispatch = useDispatch();

  useVerifyToken();

  async function fetchingUsers() {
    trackPromise(
      dispatch(
        fetchUsers({
          queries: { filters: { userSearch: typeFilter.userSearch } },
          page: typeFilter.page,
        })
      ),
      "fetching-users"
    );
  }

  useEffect(() => {
    let isMounted = true;

    if (isMounted) fetchingUsers();

    return () => (isMounted = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeFilter]);


  return (
    <>
      <TopDiv>
        <Menu />
        <MainContainer>
          <TopBar text="Membros" />
          <ContainerCenter>
            <ContainerCenterInside>
              <Header>
                <InputDiv>
                  <Input
                    value={userSearch}
                    setValue={setUserSearch}
                    Icon={() => <Search />}
                    placeholder="Pesquisar por membros"
                    buttonConfirm
                    buttonConfirmText="Pesquisar"
                    onClickButton={() => {
                      updateFilters({ ...typeFilter, userSearch: userSearch });
                    }}
                  />
                </InputDiv>
                <ProtectedComponent
                  allowed={["admin", "gerente"]}
                  rank={user?.rank}
                >
                  <Button
                    content={"Novo Usuário"}
                    onClick={() => setOpenModal("new")}
                  />
                </ProtectedComponent>
              </Header>
              <HeaderTable />
              <Dashboard>
                {!isFetching ? (
                  <>
                    {pagination.length > 0
                      ? pagination.map((item, index) => (
                        <UsersDisplay
                          user={user}
                          item={item}
                          key={index}
                          index={index}
                          handleDelete={handleDeleteUser}
                          handleTurnColaborador={handleTurnColaborator}
                          handleTurnGerente={handleTurnManager}
                        />
                      ))
                      : "Bem vindo Administrador! vamos convidar seus colegas para o Zaivu!"}
                  </>
                ) : (
                  <ReactLoading type="bars" color="#118052" />
                )}
              </Dashboard>
            </ContainerCenterInside>
          </ContainerCenter>
        </MainContainer>
        <Pagination
          style={{
            position: "absolute",
            bottom: "1.5rem",
            left: "50%",
          }}
          actualPage={typeFilter.page}
          onPageChange={(activePage) => {
            updateFilters({
              ...typeFilter,
              page: activePage,
            });
          }}
          numberOfPages={users.pages}
        />
      </TopDiv>
      <ProtectedComponent rank={user?.rank} allowed={["gerente", "admin"]}>
        <UpgradeRankModal
          isOpen={openModal === "upgrade"}
          onClose={handleCloseModal}
          item={selectedItem}
        />
        <DowngradeRankModal
          isOpen={openModal === "downgrade"}
          onClose={handleCloseModal}
          item={selectedItem}
        />
        <DeleteUserModal
          isOpen={openModal === "delete"}
          onClose={handleCloseModal}
          item={selectedItem}
          updateFilters={updateFilters}
        />
        <NewUserModal
          filters={[typeFilter, updateFilters]}
          isOpen={openModal === "new"}
          onClose={handleCloseModal}
          onConfirm={Placeholder}
        />
      </ProtectedComponent>
    </>
  );
};

export default MembersPage;
